// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_CancelInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for invoice cancellation
 */
import { registerContract } from './validate'

export interface Invoice_CancelInput {
invoice_id: number
motivo: string
}

registerContract('Invoice_CancelInput', {
  invoice_id: { type: 'number',  required: true },
  motivo:     { type: 'string',  required: true },
})
